import { render } from "./LessonProducts.vue?vue&type=template&id=0f29c895&scoped=true"
import script from "./LessonProducts.vue?vue&type=script&lang=js"
export * from "./LessonProducts.vue?vue&type=script&lang=js"

import "./LessonProducts.vue?vue&type=style&index=0&id=0f29c895&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f29c895"]])

export default __exports__